export const MAX_UINT8 = 0xff; // 255
export const MAX_UINT16 = 0xffff; // 65535
